import React from "react";


const EditPollPost = ({ poll, onClose }) => {
  if (!poll) return null;

  const { question, options = [], duration_days, closes_at, totalVotes } = poll;

  const isPollClosed = new Date() > new Date(closes_at);
  const getDurationLabel = () => {
    if (duration_days === 7) return "1w";
    if (duration_days === 21) return "3w";
    return `${duration_days} days`;
  };

  return (
    <div className="w-full max-w-xl p-4">
      <div className="border rounded-md p-4 bg-gray-50">
        <p className="text-lg font-semibold">{question}</p>

        {options.map((opt, index) => (
          <div key={index} className="w-full mt-3">
            <div className="flex justify-between items-center text-sm font-medium text-blue-600">
              <span>{opt.option_text}</span>
              <span>{opt.percentage}%</span>
            </div>
            <div className="w-full h-2 bg-gray-200 rounded-full mt-1">
              <div
                className="h-2 bg-blue-500 rounded-full"
                style={{ width: `${opt.percentage}%` }}
              ></div>
            </div>
          </div>
        ))}

        <p className="mt-4 text-sm text-blue-600 text-right">
          {totalVotes} vote{totalVotes !== 1 ? "s" : ""} •{" "}
          {isPollClosed ? "Poll closed" : `${getDurationLabel()} left`} • View results
        </p>
      </div>
    </div>
  );
};

export default EditPollPost;
